export const FRAGMENT_SHADER_SOURCE = `precision mediump float;

varying vec4 v_color;

void main() {
  gl_FragColor = v_color;
}`